import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const LandingPage = () => import('../views/LandingPage.vue');
const ErrorPage = () => import('../views/Error404.vue');

const routes = [
  {
    path: '/',
    name: 'Home',
    component: LandingPage
  },
  {
    path: '/404',
    name: '404',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: ErrorPage
  },
  {
    path: '*',
    redirect: '/404'
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router;
